import React, { ReactNode } from "react";
import Link from "next/link";
import { styled } from "@mui/material";
import { colors } from "@constants/cssVariables";

const Hyperlink = styled(Link)({
  color: colors.primary,
});

const RichTextHyperlink: React.FC<{ children: ReactNode; data?: { uri?: string } }> = ({ data, children }) => {
  if (!data?.uri) return null;

  return <Hyperlink href={data.uri}>{children}</Hyperlink>;
};

export default RichTextHyperlink;
